import styled from "styled-components"


export const CorporationManagersContainer = styled.div`
    padding: 40px;
    box-sizing: border-box;
`
